import React from 'react';
import {IconButton, Menu, MenuItem} from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import {makeStyles} from '@material-ui/core/styles';

const overrideStyle = makeStyles((theme) => ({
  danger: {
    color: theme.palette.error.main
  },
}), {name: "RaymanIconMenu"});

export default function IconMenu({items, ...props})
{
    const classes = overrideStyle();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOptionClick = (option) => {
        if(option.onClick) option.onClick();
        handleClose();
    }

    return (
        <div>
          <IconButton
            onClick={handleClick}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            {...props}
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
          >
            {items.map((option) => (
              <MenuItem className={option.danger && classes.danger} key={option.label} onClick={() => handleOptionClick(option)} disabled={option.disabled}>
                {option.label}
              </MenuItem>
            ))}
          </Menu>
        </div>
      );
}